import React, { useState } from 'react'
import { ChevronDoubleDownIcon, ChevronDoubleUpIcon } from "@heroicons/react/24/solid"
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import ViewDetailsOfHistory from './ViewDetailsOfHistory';
import dayjs from 'dayjs';
import { getToken } from '../services/Token';
import { getActorInfo } from '../utils/onBehalf';

const HALF_DAY = 0.5;

const LeaveComponent = (props) => {
    const [open, setOpen] = useState(false);
    const {toggleDetailsVisibility, data, detailsVisible, withdraw, approve, reject, adminWithdraw} = props
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    const DetailsVisibility = () => {
      if (toggleDetailsVisibility) {
        toggleDetailsVisibility(data?._id);
      }
    }
    const isDetailsVisible = detailsVisible || false;
    const actor = getActorInfo({
      actorId: data?.appliedBy,
      actorName: data?.appliedByName,
      actorRole: data?.appliedByRole,
      ownerId: data?.employeeId,
      ownerName: data?.employeeName,
    });

    const shouldShowWithDrawButton = (data)=>{
      const todayDate = new Date().toISOString()
      const appliedOn = data?.appliedOn
      const expireDate = new Date(appliedOn)
      const role = getToken('roles')
      expireDate.setMonth(expireDate.getMonth() + 6)
      if(data?.status === "APPROVED" && todayDate < expireDate.toISOString() && (role.includes("ADMIN"))){
        return true
      }else{
        return false
      }
    }
    return (
      <>
        <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
          <DialogContent>
            <ViewDetailsOfHistory data={data} />
          </DialogContent>
          <DialogActions className="my-2 m-5">
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <div className="w-11/12 my-10 mx-auto border border-slate-300 rounded-xl">
          <section
            className={`p-1 w-full flex justify-between ${
              isDetailsVisible ? "border-b-[1px]  border-slate-300" : ""
            }`}
          >
            <div className="grid grid-cols-4 gap-10 w-11/12 ">
              {data?.role === "Manager" ? (
                <>
                  <div className="my-auto mx-5">
                    <p className="text-xl">{data?.employeeName}</p>
                  </div>
                  <div className="my-auto mx-5">
                    <p>Category</p>
                    <p className="text-xl">{data?.leaveCategory}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="my-auto mx-5">
                    <p>Category</p>
                    <p className="text-xl">{data?.leaveCategory}</p>
                  </div>
                  <div className="my-auto mx-5">
                    <p>Holiday</p>
                    <p className="text-xl">{data?.leaveCategory}</p>
                  </div>
                </>
              )}
              <div className="my-auto mx-5">
                <p>No. of days</p>
                <div className="flex items-center gap-2">
                  <p className="text-xl">{data?.days}</p>
                  {data?.days != null && data.days <= HALF_DAY && (
                    <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 border border-amber-300">
                      Half Day
                    </span>
                  )}
                </div>
              </div>
              <div className="my-auto mx-5">
                <p
                  className={`${
                    data?.status === "APPROVED"
                      ? "text-blue-500"
                      : "text-red-600"
                  } text-xl`}
                >
                  {data?.status === "CANCELLED" ? "WITHDRAWAL" : data?.status}
                </p>
                {actor.isOnBehalf && (
                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 border border-blue-300">
                    On behalf
                  </span>
                )}
              </div>
            </div>
            <div className="my-auto items-end w-1/12">
              {isDetailsVisible ? (
                <ChevronDoubleUpIcon
                  className="h-7 text-black cursor-pointer"
                  onClick={DetailsVisibility}
                />
              ) : (
                <ChevronDoubleDownIcon
                  className="h-7 text-black cursor-pointer"
                  onClick={DetailsVisibility}
                />
              )}
            </div>
          </section>
          <div
            className={`overflow-hidden transition-transform transform ${
              isDetailsVisible ? "max-h-screen" : "max-h-0"
            }`}
          >
            <section
              className={`w-full p-1 flex flex-row justify-between ${
                isDetailsVisible ? "border-b-[1px] border-slate-300" : ""
              }`}
            >
              <div className="my-auto mx-5">
                <p>
                  <span className="text-l">Duration :</span>
                  {dayjs(data?.fromDate).format("DD MMM YYYY") 
                  + " - " +
                    dayjs(data?.toDate).format("DD MMM YYYY")}
                </p>
                <p>
                  <span className="text-l">Remarks :</span>{" "}
                  {data?.leaveReason}{" "}
                </p>
              </div>
            </section>

            <section className="w-full flex flex-row justify-between p-1">
              <div className="my-auto mx-5">
                <p>Applied On</p>
                <p className="text-l">{dayjs(data?.appliedOn)?.format("DD MMM YYYY")}</p>
                {actor.isOnBehalf && (
                  <p className="text-sm text-gray-600">
                    Applied by {actor.actorName}
                    {actor.roleLabel ? ` (${actor.roleLabel})` : ""}
                  </p>
                )}
              </div>
              <div className="my-auto mx-5 flex space-x-5 text-blue-500 ">
                <p className="cursor-pointer text-xl" onClick={handleClickOpen}>
                  View Details
                </p>
                {data?.button === "Pending" ? (
                  <p
                    className="cursor-pointer text-xl"
                    onClick={() => withdraw(data?._id)}
                  >
                    Withdraw
                  </p>
                ) : (
                  ""
                )}
                {data?.button === "Approve" ? (
                  <p
                    className="cursor-pointer text-xl"
                    onClick={() => {
                      if (toggleDetailsVisibility) {
                        toggleDetailsVisibility(data?._id, false);
                      }
                      reject(data?._id);
                    }}
                  >
                    Reject
                  </p>
                ) : (
                  ""
                )}
                {data?.button === "Approve" ? (
                  <p
                    className="cursor-pointer text-xl"
                    onClick={() => {
                      if (toggleDetailsVisibility) {
                        toggleDetailsVisibility(data?._id, false);
                      }
                      approve(data?._id);
                    }}
                  >
                    Approve
                  </p>
                ) : (
                  ""
                )}
                {shouldShowWithDrawButton(data) ? (
                  <p
                    className="cursor-pointer text-xl"
                    onClick={() => {
                      if (toggleDetailsVisibility) {
                        toggleDetailsVisibility(data?._id, false);
                      }
                      adminWithdraw(data?._id);
                    }}
                  >
                    Withdraw Leave
                  </p>
                ) : (
                  ""
                )}
              </div>
            </section>
          </div>
        </div>
      </>
    );
}

export default LeaveComponent